class HeaderFunc {
  constructor(selector) {
    // console.log(this);
    // console.log(selector);
    // this.element = document.querySelector(selector);
    // console.log(this.element);

    const header = this;
    header.elements = document.querySelector(selector);
    header.body = header.elements.querySelector("header");

    // 新規：対象セクション
    header.whiteSections = document.querySelectorAll(".js-headerWhite");
    header.transparentSections = document.querySelectorAll(
      ".js-headerTransparent",
    );

    window.addEventListener("scroll", this.onScroll.bind(this)); // 新規追加

    header.init();
    header.onScroll(); // 初期状態もチェック
  }

  init() {
    const header = this;

    let headerHeight = 0;

    const styles = window.getComputedStyle(header.elements);
    const parent = header.elements.closest(".section-header");
    let stylesParent = null;
    if (parent) {
      stylesParent = window.getComputedStyle(parent);
    }
    console.log(styles.position);
    console.log(stylesParent.position);
    if (styles.position === "sticky" || stylesParent?.position === "sticky") {
      headerHeight = header.elements.offsetHeight;
    }

    const announcementbar = document.querySelector(".announcement-bar-section");
    if (announcementbar) {
      headerHeight += announcementbar.clientHeight;
    }

    document.documentElement.style.setProperty(
      "--header-height",
      `${headerHeight}px`,
    );
  }

  onScroll() {
    const header = this;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = header.body.offsetHeight;
    const borderLine = scrollTop + headerHeight * 0.5;

    let isWhite = false;
    let isTransparent = false;

    // .js-headerWhite の中に borderLine があるか判定
    header.whiteSections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const top = scrollTop + rect.top;
      const bottom = top + rect.height;
      if (borderLine >= top && borderLine <= bottom) {
        isWhite = true;
      }
    });

    // .js-headerTransparent の中に borderLine があるか判定
    header.transparentSections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const top = scrollTop + rect.top;
      const bottom = top + rect.height;
      if (borderLine >= top && borderLine <= bottom) {
        isTransparent = true;
      }
    });

    // クラスの切り替え処理
    // 対象要素：ヘッダー本体とサブナビ
    const targets = [header.elements, header.body];
    const subnav = document.querySelector(".dl-common_subnav");
    if (subnav) {
      targets.push(subnav);
    }

    // クラスの切り替え処理（共通）
    targets.forEach((el) => {
      if (isWhite) {
        DL_addClass(el, "is-white");
      } else {
        DL_removeClass(el, "is-white");
      }

      if (isTransparent) {
        DL_addClass(el, "is-transparent");
      } else {
        DL_removeClass(el, "is-transparent");
      }
    });
  }
}
new HeaderFunc(".header");
